import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

import TitledContainer, { StaticText } from "../TitledContainer";

import styles from "./TitledText.css";

export default class TitledText extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      original: this.props.text,
      value: this.props.text || "",
      isChanged: false,
      focus: props.autoFocus,
      isEdit: props.isEdit || false,
    };
    this.handleBlur = this.handleBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      isEdit: nextProps.isEdit,
      value: nextProps.text || "",
      original: nextProps.text,
      isChanged: false,
    });
  }

  handleEdit() {
    this.setState({ isEdit: true, focus: true }, () => {
      if (this.props.onEdit) this.props.onEdit();
    });
  }

  handleChange(e) {
    this.setState({ value: e.target.value });
    this.props.onInput(e.target.value);
  }

  handleBlur() {
    this.setState({ isChanged: this.state.original !== this.state.value });
  }

  render() {
    const content = this.state.isEdit ? (
      <input
        autoFocus={this.state.focus}
        className={classnames(
          { [styles.required]: this.props.isRequired && !this.state.value },
          { [styles.changed]: this.state.isChanged }
        )}
        onBlur={this.handleBlur}
        onChange={this.handleChange}
        placeholder={this.state.isEdit ? this.props.placeholder : "-"}
        readOnly={this.props.isReadOnly}
        ref={(ref) => {
          this.input = ref;
        }}
        type={this.props.type}
        value={this.state.value}
      />
    ) : (
      <StaticText isImportant={this.props.isImportant} text={this.state.value} />
    );

    return (
      <TitledContainer
        infoComponent={this.props.infoComponent}
        isEdit={this.state.isEdit}
        isEmpty={!this.state.value}
        isLarge={this.props.isLarge}
        onEdit={this.handleEdit}
        title={this.props.title}
        isEditable
      >
        <div className={styles.content}>{content}</div>
      </TitledContainer>
    );
  }
}

TitledText.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  isImportant: PropTypes.bool,
  isEdit: PropTypes.bool,
  isRequired: PropTypes.bool,
  isLarge: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  onInput: PropTypes.func,
  onEdit: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.oneOf(["email", "password", "text"]),
  infoComponent: PropTypes.node,
  autoFocus: PropTypes.bool,
};

TitledText.defaultProps = {
  placeholder: "",
  type: "text",
};
